import axios from 'axios';
import { getApiUrl } from '../lib/api-url';
import type { PortfolioMediaType, VideoPlatform } from '../lib/portfolio-media';

export interface PortfolioItem {
    id: string;
    title: string;
    artist?: string | null;
    description?: string;
    category?: string;
    categoryObject?: {
        name: string;
        slug: string;
    };
    categoryId?: string;
    mediaType?: PortfolioMediaType;
    coverUrl: string;
    galleryUrls: string[];
    videoUrl?: string | null;
    platform?: VideoPlatform | null;
    eventDate?: string;
    isActive: boolean;
}

export const portfolioService = {
    getAll: async () => {
        const response = await axios.get<PortfolioItem[]>(`${getApiUrl()}/portfolio-items`);
        return response.data;
    },

    getOne: async (id: string) => {
        const response = await axios.get<PortfolioItem>(`${getApiUrl()}/portfolio-items/${id}`);
        return response.data;
    }
};
